"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringFormat = void 0;
var string_format_1 = __importDefault(require("string-format"));
var StringFormat = /** @class */function () {
  function StringFormat() {}
  StringFormat.prototype.format = function (value, stringFormatData) {
    if (stringFormatData && stringFormatData.length > 0) {
      return string_format_1.default.apply(void 0, __spreadArrays([value], stringFormatData));
    }
    return value;
  };
  return StringFormat;
}();
exports.StringFormat = StringFormat;